import { render, staticRenderFns } from "./Retail.vue?vue&type=template&id=fbd8935e&scoped=true"
import script from "./Retail.vue?vue&type=script&lang=js"
export * from "./Retail.vue?vue&type=script&lang=js"
import style0 from "./Retail.vue?vue&type=style&index=0&id=fbd8935e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd8935e",
  null
  
)

export default component.exports